export default "__VITE_ASSET__53msVhaT__"